import { Pipe, PipeTransform } from '@angular/core';
import { getBytesToSize } from './data.functions';

@Pipe({
  name: 'bytes'
})
export class BytesPipe implements PipeTransform {
    transform(size?: number | string, decimals?: number): string {
        return getBytesToSize(size, decimals);
    }
};